import {Box, Stack} from '@mui/material';
import Lightning from 'components/animation/Lightning';
import {ReactNode} from 'react';

export default function BG(props: {type: 'lightning' | 'dark-veil' | 'galaxy' | 'liquid' | 'terminal'; subtle?: string; size?: string; padding?: string; children: ReactNode}) {
	const {type, children, subtle, size = '50%', padding} = props;

	return (
		<Stack id="full-canvas" width="100%" height="100%">
			<Box id="background" zIndex={1} position="absolute" top={0} left={0} width="100%" height="100%" overflow="hidden" bgcolor="black">
				{type === 'lightning' && <Lightning hue={220} xOffset={0} speed={1} intensity={1} size={1} />}
			</Box>

			{subtle && (
				<Box id="subtle-image" zIndex={2} position="absolute" top={0} left={0} width="100%" height="100%" overflow="hidden">
					<Box
						id="bg-image"
						component="img"
						position="absolute"
						bottom={size === '100%' ? -200 : 10}
						right={10}
						src={subtle}
						width={size}
						sx={{opacity: 0.4, filter: 'brightness(0.6) contrast(1.2) saturate(0.8)'}}
					/>
				</Box>
			)}

			<Box id="viewport" position="relative" zIndex={10} width="100%" height="100%" padding={padding}>
				<Stack id="full-cover" width="100%" height="100%" overflow="auto">
					{children}
				</Stack>
			</Box>
		</Stack>
	);
}
